import { DataBean } from "../DataBean";

export class Kpi extends DataBean {



    // public async getKpiCatalog(processType: any): Promise<any> {
    //     return this.getCustomService("QuickDataERPCore", "java.util.List_getKpiCatalog_Number", [processType]);
    // }
    public async getKpiCatalog(processType: any, idStrategicObjective: any, idLnFunctionalID: any, idAccountResponsible: any, state: any, regexStr: any, page: any, recordsPerPage: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getKpiCatalog_Number_Number_Number_Number_Number_String_Number_Number", [processType, idStrategicObjective, idLnFunctionalID, idAccountResponsible, state, regexStr, page, recordsPerPage]);
    }
    public async getKpiCatalogByDash(idDashBoard: any, processType: any, idStrategicObjective: any, idLnFunctionalID: any, idAccountResponsible: any, state: any, regexStr: any, page: any, recordsPerPage: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getKpiCatalog_Number_Number_Number_Number_Number_Number_String_Number_Number", [idDashBoard, processType, idStrategicObjective, idLnFunctionalID, idAccountResponsible, state, regexStr, page, recordsPerPage]);
    }
    public async deleteKpi(idKpi: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "void_deleteKpi_Number", [idKpi]);
    }

    public async updateKpi(bean): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "void_updateKpi_com.quickdataerp.bean.bi.Kpi", [
            {
                "DataBeanProperties": bean,
                "DataBeanName": "com.quickdataerp.bean.bi.Kpi"
            }
        ]);
    }

}